<template>
  <video
    id="video"
    :poster="poster || videoImg"
    :src="src"
    class="video"
    controls
    controlslist="nodownload"
    height="auto"
    preload="metadata"
    width="100%"
  ></video>
</template>

<script>
  import card from '@views/general/modules/Card.vue'

  export default {
    name: 'PVideo',
    components: { card },
    props: {
      src: {
        type: String,
        default: ''
      },
      poster: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        videoImg: ''
      }
    },
    watch: {
      CommodityVideoIntroduction() {
        console.log('video->' + this.src)
        this.getVideoBase64(this.src)
          .then((dataUrl) => {
            console.log('url->' + dataUrl)
            this.videoImg = dataUrl
          })
          .catch((error) => {
            console.error(error) // 打印错误信息
          })
      }
    },
    methods: {
      getVideoBase64(url) {
        return new Promise(resolve => {
          let dataURL = ''
          const video = document.createElement('video')
          video.setAttribute('crossOrigin', 'anonymous')// 处理跨域
          video.setAttribute('src', url)
          video.setAttribute('width', '400')
          video.setAttribute('height', '240')
          video.setAttribute('preload', 'auto') // 防止截取图片黑屏的关键属性
          video.setAttribute('autoplay', 'autoplay')
          video.addEventListener('loadeddata', () => {
            const canvas = document.createElement('canvas')
            const width = video.videoWidth // canvas的尺寸和视频一样
            const height = video.videoHeight
            canvas.width = width
            canvas.height = height
            canvas.getContext('2d').drawImage(video, 0, 0, width, height) // 绘制canvas
            const imageData = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height) // 绘制canvas
            const arr = imageData.data
            dataURL = canvas.toDataURL('image/png') // 转换为base64
            const brr = []
            for (let a = 0; a < arr.length; a++) {
              const arrItem = arr[a]
              if (arrItem > 0 && arrItem < 200) {
                brr.push(arrItem)
              }
            }
            if (!brr.length) {
            // 截取的图片无效（黑屏、白屏、透明），这里可以返回系统默认图片
            }
            resolve(dataURL)
          })
        })
      },
      getVideoFirstFrame(videoUrl) {
        // debugger
        // 创建video元素
        const video = document.createElement('video')
        video.src = videoUrl
        video.setAttribute('crossOrigin', 'Anonymous') // 处理跨域
        video.setAttribute('preload', 'auto') // auto|metadata|none
        // 等待视频加载完成
        return new Promise((resolve, reject) => {
          video.addEventListener('loadedmetadata', () => {
            // 创建canvas元素
            const canvas = document.createElement('canvas')
            canvas.width = video.videoWidth
            canvas.height = video.videoHeight

            // 将视频第一帧绘制到canvas上
            const ctx = canvas.getContext('2d')

            ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

            // 将canvas图像转换为base64格式的数据URI
            const dataUrl = canvas.toDataURL()

            // 返回base64格式的数据URI
            resolve(dataUrl)
          })

          // 如果视频加载出错，则返回错误信息
          video.addEventListener('error', () => {
            reject(`Failed to load video: ${videoUrl}`)
          })
        })
      }
    }
  }
</script>

<style lang="less" scoped>
.widthStyle {
  width: 18rem;
  word-wrap: break-word;
}

.origin-description {
  width: 90%;
  margin: 0 auto;
  padding: 0 2%;
  background-color: #000000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .introduce {
    width: 100%;
    font-size: 1rem;
    margin: 0.5rem 0;
    color: #faefac;
  }

  .pic-top {
    display: flex;

    .top-item {
      width: 100%;

      img {
        width: 100%;
        height: 10rem;
      }
    }

    .top-item-left {
      margin-right: 0.2rem;
    }

    .top-item-right {
      margin-left: 0.2rem;
    }
  }

  .pic-btm {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }
}
</style>
